const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy40MTQyIDEyTDE5Ljc3ODIgMTguMzY0TDE4LjM2NCAxOS43NzgyTDEyIDEzLjQxNDJMNS42MzYwNCAxOS43NzgyTDQuMjIxODMgMTguMzY0TDEwLjU4NTggMTJMNC4yMjE4MyA1LjYzNjA0TDUuNjM2MDQgNC4yMjE4M0wxMiAxMC41ODU4TDE4LjM2NCA0LjIyMTgzTDE5Ljc3ODIgNS42MzYwNEwxMy40MTQyIDEyWiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=close-1afccf6c.mjs.map
